var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2.5H6.66667C4.375 2.5 2.5 4.375 2.5 6.66667V13.3333C2.5 15.625 4.375 17.5 6.66667 17.5H9.17667V11.2508H8.12583C7.78083 11.2508 7.50083 10.9708 7.50083 10.6258C7.50083 10.2808 7.78083 10.0008 8.12583 10.0008H9.17667V8.9625C9.17667 7.69833 10.2042 6.67083 11.4683 6.67083H12.71C13.055 6.67083 13.335 6.95083 13.335 7.29583C13.335 7.64083 13.055 7.92083 12.71 7.92083H11.4683C10.8942 7.92083 10.4267 8.38833 10.4267 8.9625V10.0008H12.71C13.055 10.0008 13.335 10.2808 13.335 10.6258C13.335 10.9708 13.055 11.2508 12.71 11.2508H10.4267V17.5H13.3333C15.625 17.5 17.5 15.625 17.5 13.3333V6.66667C17.5 4.375 15.625 2.5 13.3333 2.5Z",
    fill: "#F5F4F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIc);
export default __webpack_public_path__ + "static/media/fb_ic.b373082c.svg";
export { ForwardRef as ReactComponent };